import React from "react";

const PropertySVG = ({ activeSvgColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 35 30"
      fill="none"
    >
      <path
        d="M26 12.5H29.5V16.5H26"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 20.5H29.5V24.5H26"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 12.5H6V16.5H9.5"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.75 16.25L19.75 12.75L15.75 12.75L15.75 16.25"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 16.5H21.5"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 23L15.75 28.5L19.75 28.5L19.75 23"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 22.75L14 22.75"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 20.5H6V24.5H9.5"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 28.5H33V9.5L25.5 2L22 5.5"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 28.5H2V9.5L9.5 2L13 5.5"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 28.5V9L17.75 2L10 9V28.5H25.5Z"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    // <svg
    //   width="17"
    //   height="17"
    //   viewBox="0 0 17 17"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M2.16667 4.33333C3.36328 4.33333 4.33333 3.36328 4.33333 2.16667C4.33333 0.97005 3.36328 0 2.16667 0C0.97005 0 0 0.97005 0 2.16667C0 3.36328 0.97005 4.33333 2.16667 4.33333Z"
    //     fill={activeSvgColor}
    //   />
    //   <path
    //     d="M2.16667 10.4998C3.36328 10.4998 4.33333 9.52983 4.33333 8.33316C4.33333 7.13658 3.36328 6.1665 2.16667 6.1665C0.97005 6.1665 0 7.13658 0 8.33316C0 9.52983 0.97005 10.4998 2.16667 10.4998Z"
    //     fill={activeSvgColor}
    //   />
    //   <path
    //     d="M2.16667 16.6663C3.36328 16.6663 4.33333 15.6963 4.33333 14.4997C4.33333 13.3031 3.36328 12.333 2.16667 12.333C0.97005 12.333 0 13.3031 0 14.4997C0 15.6963 0.97005 16.6663 2.16667 16.6663Z"
    //     fill={activeSvgColor}
    //   />
    //   <path
    //     d="M6.99935 3.74967H15.166C15.9993 3.74967 16.7493 3.08301 16.7493 2.16634C16.7493 1.33301 16.0827 0.583008 15.166 0.583008H6.99935C6.16602 0.583008 5.41602 1.24967 5.41602 2.16634C5.41602 2.99967 6.08268 3.74967 6.99935 3.74967Z"
    //     fill={activeSvgColor}
    //   />
    //   <path
    //     d="M15.0827 6.75H6.99935C6.16602 6.75 5.41602 7.41667 5.41602 8.33333C5.41602 9.16667 6.08268 9.91667 6.99935 9.91667H15.166C15.9993 9.91667 16.7493 9.25 16.7493 8.33333C16.666 7.5 15.9993 6.75 15.0827 6.75Z"
    //     fill={activeSvgColor}
    //   />
    //   <path
    //     d="M15.0827 12.9165H6.99935C6.16602 12.9165 5.41602 13.5832 5.41602 14.4998C5.41602 15.3332 6.08268 16.0832 6.99935 16.0832H15.166C15.9994 16.0832 16.7493 15.4165 16.7493 14.4998C16.666 13.5832 15.9993 12.9165 15.0827 12.9165Z"
    //     fill={activeSvgColor}
    //   />
    // </svg>
  );
};

export default PropertySVG;
